import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  getBiller,
  getListBillerPrefix,
  billerCreatePrefix,
  billerEditPrefix,
  billerDeletePrefix,
  billerArchive,
  updatePreferredPrefix,
  getListBillerBankAccount,
  billerCreateBankAccount,
  billerUpdatePreferredBankAccount,
  billerDeleteBankAccount,
} from '../../redux/actions/billers';
import {
  getListBank,
  getNonMandatoryVaPrefixBankList,
} from '../../redux/actions/banks';
import { getTncDetail } from '../../redux/actions/tnc';
import { getListPaymentMethod } from '../../redux/actions/paymentMethods';
import { getChannelList } from '../../redux/actions/channel';
import BillerDetail from './BillerDetail.page';

const mapStateToProps = state => ({
  biller: state.allbiller.biller,
  loading: state.allbiller.loading,
  loadingPrefix: state.allbiller.loadingPrefix,
  listBillerPrefix: state.allbiller.listBillerPrefix,
  listBillerBankAccount: state.allbiller.listBillerBankAccount,
  listBank: state.allbiller.listBank,
  listPaymentMethod: state.allbiller.listPaymentMethod,
  tnc: state.allbiller.tncDetail,
  channelList: state.allbiller.channelList,
  nonMandatoryVaPrefixBankList: state.allbiller.nonMandatoryVaPrefixBankList,
});

const mapDispatchToProps = {
  getBiller,
  getListBillerPrefix,
  getListBillerBankAccount,
  billerCreatePrefix,
  billerEditPrefix,
  billerDeletePrefix,
  getListBank,
  billerArchive,
  updatePreferredPrefix,
  billerCreateBankAccount,
  billerUpdatePreferredBankAccount,
  billerDeleteBankAccount,
  getTncDetail,
  getListPaymentMethod,
  getChannelList,
  getNonMandatoryVaPrefixBankList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(BillerDetail));
